module.exports = __webpack_public_path__ + "images/2aec2cbcc7ed4881776c3295f1087832a.svg";